// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + {"12":"profiler","9777":"recorder"}[chunkId] + "." + {"12":"e4f5f002e9b5c7fc","9777":"058dda33abea73bb"}[chunkId] + ".js";
};